import type { OperationVariables, QueryHookOptions } from '@apollo/client';
import { LinearProgress } from '@mui/material';
import React, { type ReactNode } from 'react';
import { type ParsedSuperViewData, parseSuperView, type SuperViewResponse } from 'src/api/viewModels/data';
import { useSuperView } from 'src/hooks/super';

interface SuperViewChildProps {
  data?: ParsedSuperViewData[];
}

interface SuperViewWrapperProps {
  children: ReactNode;
  shared?: boolean;
  useQueryArgs?: QueryHookOptions<unknown, OperationVariables>;
}

export const SuperViewWrapper: React.FC<SuperViewWrapperProps> = ({ children, shared, useQueryArgs }) => {
  const { data, loading, error } = useSuperView<SuperViewResponse>(
    shared ? 'shared' : '',
    useQueryArgs as QueryHookOptions<SuperViewResponse, OperationVariables>,
  );

  if (loading) {
    return <LinearProgress color="secondary" />;
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  const parsedData = parseSuperView(data, shared);
  return (
    <>
      {React.Children?.map(children, (child) =>
        React.isValidElement<SuperViewChildProps>(child) ? React.cloneElement(child, { data: parsedData }) : child,
      )}
    </>
  );
};
